import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectFieldMappingsByType } from 'modules/catalog/collectionBuilder/selectors';
import {
  changeQuerySizeLimit,
  changeQueryOrderBy,
} from 'modules/queryBuilder/legacyQueryBuilder/actions';
import {
  selectAllFields,
  selectOrderByDynamicLocation,
  selectOrderByField,
  selectOrderByIsSortAsc,
  selectOrderByLocation,
  selectSizeLimit,
  selectSizeLimitMax,
} from 'modules/queryBuilder/legacyQueryBuilder/selectors';
import LimitAndOrderByRow from './LimitAndOrderByRow';

const LimitAndOrderByRowContainer = (props) => <LimitAndOrderByRow {...props} />;

const mapStateToProps = (state) => ({
  dynamicLocation: selectOrderByDynamicLocation(state),
  field: selectOrderByField(state),
  fields: selectAllFields(state),
  isSortAsc: selectOrderByIsSortAsc(state),
  location: selectOrderByLocation(state),
  sizeLimit: selectSizeLimit(state),
  sizeLimitMax: selectSizeLimitMax(state),
  userMappings: selectFieldMappingsByType(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeOrderBy: changeQueryOrderBy,
      changeSizeLimit: changeQuerySizeLimit,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(LimitAndOrderByRowContainer);
